module.exports = __webpack_public_path__ + "static/media/support4.f47735e9.svg";